import qs from 'query-string'
import getRequest from 'utils/getRequest'
import postRequest from 'utils/postRequest'
import deleteRequest from 'utils/deleteRequest'

const path = '/api/bulk-import-access'

export const requestGetBulkImportAccess = ({
  resultsPerPage = 12,
  currentPage = 1,
  query = '',
  role = '',
  country = '',
  hasApiKey = '',
  sortBy = 'grantedAt',
  sortDirection = 'DESC',
  signal
} = {}) => {
  const queryStringParsed = qs.stringify({
    resultsPerPage,
    currentPage,
    query,
    role,
    country,
    hasApiKey,
    sortBy,
    sortDirection
  })
  return getRequest(`${path}/?${queryStringParsed}`, signal)
}

export const requestSearchBulkImportUsers = ({ query = '', signal } = {}) => {
  const queryStringParsed = qs.stringify({ query })
  return getRequest(`${path}/users?${queryStringParsed}`, signal)
}

export const requestAddBulkImportAccess = ({ userId, email } = {}) => {
  return postRequest(path, { userId, email })
}

export const requestRemoveBulkImportAccess = (userId) => {
  return deleteRequest(`${path}/${userId}`)
}

export const requestGenerateBulkImportUserApiKey = (userId) => {
  return postRequest(`${path}/${userId}/api-key`)
}

export const requestDeleteBulkImportUserApiKey = (userId) => {
  return deleteRequest(`${path}/${userId}/api-key`)
}
